import { Injectable, Inject } from '@angular/core';
import { CoreConfig, CORE_CONFIG } from '../../core.config.module';

import { IAnalytic, IUser } from '@app/core/interfaces';

import posthog from 'posthog-js';

// TODO: Rename this to a generic 'TrackingService';
@Injectable({
    providedIn: 'root'
})
export class MixpanelService implements IAnalytic {
    private isInitialized = false;
    constructor(@Inject(CORE_CONFIG) private config: CoreConfig) {}

    public initialize(user: IUser) {
        if (this.isInitialized) return;

        posthog.init(this.config.posthogKey, {
            api_host: this.config.posthogHost,
            loaded: (posthog) => {
                posthog.identify(user.id, {
                    email: user.email,
                    info: user.info
                });
                posthog.capture('WebappView');
            }
        });

        this.isInitialized = true;
    }

    /** When page views are not captured by auto-capture because our app is a SPA e.g. onboarding, wizard, we need to call it ourselves */
    public capturePageView(properties: { $current_url?: string; [key: string]: string }) {
        if (!this.isInitialized) return;

        posthog.capture('$pageview', {
            ...properties
        });
    }

    /** helper method for AngularJS service */
    public capture(event: string, properties?: IUser) {
        if (!this.isInitialized) return;

        posthog.capture(event, properties);
    }

    /** helper method for downgraded AngularJS service */
    public identify(id: string, properties?: IUser) {
        if (!this.isInitialized) return;

        posthog.identify(id, properties);
    }

    public trackPlatformEvent(
        action: string,
        app: string,
        platform: 'outlook' | 'web',
        data?: { [index: string]: any },
        user?: IUser
    ) {
        if (!this.isInitialized) return;

        this.trackEvent(action, app, { ...(data || {}), messenger: platform }, user);
    }

    public trackEvent(action: string, app: string, data?: { [index: string]: any }, user?: IUser): void {
        if (!this.isInitialized) return;

        const currentUser: IUser | null = user;
        if (!currentUser) return;

        const event: string = `${app}.${action}`;

        posthog.capture(event, data);
    }

    public reset() {
        if (!this.isInitialized) return;
        posthog.reset();
    }
}
